'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DISTANCE_FROM_TOOLTIP_MARKER = 35;

var TooltipTextBubble = function (_PureComponent) {
    _inherits(TooltipTextBubble, _PureComponent);

    function TooltipTextBubble() {
        _classCallCheck(this, TooltipTextBubble);

        var _this = _possibleConstructorReturn(this, (TooltipTextBubble.__proto__ || Object.getPrototypeOf(TooltipTextBubble)).apply(this, arguments));

        _this.state = { show: false, position: { x: null, y: null } };
        _this.dimensions = { width: 0, height: 0 };
        _this.onContainerRef = function (ref) {
            _this.containerNode = ref;
        };
        return _this;
    }

    _createClass(TooltipTextBubble, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var componentRef = this.props.componentRef;

            componentRef(this);

            var _containerNode$getBou = this.containerNode.getBoundingClientRect(),
                width = _containerNode$getBou.width,
                height = _containerNode$getBou.height;

            this.dimensions = { width: width, height: height };
        }
    }, {
        key: 'calculateArrowPosition',
        value: function calculateArrowPosition(bubblePosition, _ref) {
            var horizontalAlignment = _ref.horizontalAlignment,
                verticalAlignment = _ref.verticalAlignment;

            if (!this.containerNode) {
                return { x: 0, y: 0 };
            }
            var dimensions = this.containerNode.getBoundingClientRect();
            var verticalCoefficient = verticalAlignment === 'top' ? 1 : 0;
            var alignmentCoefficient = horizontalAlignment === 'left' ? 1 : 0;
            var _props = this.props,
                arrowWidth = _props.arrowWidth,
                arrowHeight = _props.arrowHeight;

            return {
                x: bubblePosition.x + arrowWidth + dimensions.width * 0.8 * alignmentCoefficient,
                y: bubblePosition.y + verticalCoefficient * dimensions.height - arrowHeight / 2 + 1 - 2 * verticalCoefficient
            };
        }
    }, {
        key: 'calculateBubblePosition',
        value: function calculateBubblePosition(iconPosition, _ref2) {
            var verticalAlignment = _ref2.verticalAlignment,
                horizontalAlignment = _ref2.horizontalAlignment;

            if (!this.containerNode) {
                return { x: 0, y: 0 };
            }
            var dimensions = this.containerNode.getBoundingClientRect();
            var alignmentCoefficient = horizontalAlignment === 'left' ? 1 : 0;
            var verticalCoefficient = verticalAlignment === 'bottom' ? 1 : -0.5; // in all honesty, no clue why the -0.5...
            var contentCoefficient = verticalAlignment === 'top' ? -1 : 0;
            var distanceFromTooltipMarker = this.props.distanceFromTooltipMarker;

            return {
                x: iconPosition.x - dimensions.width * 0.8 * alignmentCoefficient,
                y: iconPosition.y + verticalCoefficient * distanceFromTooltipMarker + contentCoefficient * dimensions.height
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                verticalAlignment = _props2.verticalAlignment,
                horizontalAlignment = _props2.horizontalAlignment,
                backgroundColor = _props2.backgroundColor,
                arrowClassName = _props2.arrowClassName,
                contentClassName = _props2.contentClassName,
                className = _props2.className,
                arrowHeight = _props2.arrowHeight,
                arrowWidth = _props2.arrowWidth,
                borderColor = _props2.borderColor,
                onMouseEntersTooltip = _props2.onMouseEntersTooltip,
                onMouseLeavesTooltip = _props2.onMouseLeavesTooltip;
            var _state = this.state,
                position = _state.position,
                show = _state.show;

            var classNames = 'luna-tooltip ' + (show ? 'is-active' : '');
            var bubblePosition = this.calculateBubblePosition(position, {
                verticalAlignment: verticalAlignment,
                horizontalAlignment: horizontalAlignment
            });
            var arrowPosition = this.calculateArrowPosition(bubblePosition, {
                verticalAlignment: verticalAlignment,
                horizontalAlignment: horizontalAlignment
            });
            var children = this.props.children;

            return _react2.default.createElement("div", { ref: this.onContainerRef, className: classNames + ' ' + className, onMouseEnter: onMouseEntersTooltip, onMouseLeave: onMouseLeavesTooltip, style: {
                    backgroundColor: backgroundColor,
                    borderColor: borderColor || backgroundColor,
                    top: bubblePosition.y,
                    left: bubblePosition.x
                } }, _react2.default.createElement(_styles.Arrow, { className: 'luna-tooltipArrow ' + arrowClassName, verticalAlignment: verticalAlignment, horizontalAlignment: horizontalAlignment, arrowPosition: arrowPosition, borderColor: borderColor, backgroundColor: backgroundColor, height: arrowHeight, width: arrowWidth }), _react2.default.createElement("span", { className: contentClassName }, children));
        }
    }]);

    return TooltipTextBubble;
}(_react.PureComponent);

exports.default = TooltipTextBubble;

TooltipTextBubble.propTypes = {
    arrowWidth: _propTypes2.default.number,
    arrowHeight: _propTypes2.default.number,
    verticalAlignment: _propTypes2.default.oneOf(['top', 'bottom']),
    horizontalAlignment: _propTypes2.default.oneOf(['left', 'right']),
    backgroundColor: _propTypes2.default.string,
    arrowClassName: _propTypes2.default.string,
    contentClassName: _propTypes2.default.string,
    className: _propTypes2.default.string,
    componentRef: _propTypes2.default.func.isRequired,
    distanceFromTooltipMarker: _propTypes2.default.number,
    children: _propTypes2.default.string.isRequired,
    borderColor: _propTypes2.default.string,
    onMouseEntersTooltip: _propTypes2.default.func.isRequired,
    onMouseLeavesTooltip: _propTypes2.default.func.isRequired
};
TooltipTextBubble.defaultProps = {
    arrowHeight: 12,
    arrowWidth: 12,
    borderColor: '',
    verticalAlignment: 'bottom',
    horizontalAlignment: 'right',
    backgroundColor: '#5ab1fe',
    className: '',
    arrowClassName: '',
    contentClassName: undefined,
    distanceFromTooltipMarker: DISTANCE_FROM_TOOLTIP_MARKER
};
//# sourceMappingURL=TextBubble.js.map